import React from 'react';

import './Onboarding.scss';
import Provider from './contexts/OnboardingContext';
import OnboardingContent from './OnboardingContent';

const Onboarding = () => {
    return (
        <Provider>
            <OnboardingContent />
        </Provider>
    );
};

Onboarding.propTypes = {};

export default Onboarding;
